import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
const programs = [{
  title: 'Mini Troopers Program',
  age: 'Ages 3-5',
  description: 'Perfect for active preschoolers who need a positive outlet for their energy. Our Mini Troopers program focuses on basic listening skills, coordination, sharing on the mat, and following directions in a fun, structured environment.',
  benefits: ['Listening Skills', 'Coordination', 'Focus', 'Respect'],
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Mini-Troopers-Storm-Taekwondo.jpg',
  href: '/mini-troopers'
}, {
  title: 'Kids Taekwondo Classes',
  age: 'Ages 6+',
  description: 'Structured classes that teach respect, goal setting, and self-defense fundamentals. We help kids build unshakeable confidence and discipline that carries over into their schoolwork and home life.',
  benefits: ['Confidence Building', 'Discipline', 'Self-Defense', 'Goal Setting'],
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Discover%20the%20Perfect%20Program%20for%20Your%20Mini%20Trooper.png',
  href: '/kids-taekwondo-classes'
}, {
  title: 'Adult Taekwondo Classes',
  age: 'Adults',
  description: 'Beginner-friendly classes focused on fitness, confidence, and practical martial arts skills. Whether you want to get in shape, learn self-defense, or find a new hobby, our adult classes provide a supportive environment.',
  benefits: ['Physical Fitness', 'Stress Relief', 'Self-Defense', 'Flexibility'],
  image: 'https://cdn.magicpatterns.com/uploads/t7AgirMmJivJBXyaULHJUS/Adult.png',
  href: '/adult-taekwondo-classes'
}, {
  title: 'Family Martial Arts Classes',
  age: 'All Ages',
  description: 'Families looking for a healthy, active hobby they can do on the same mat. Train together, grow together, and build confidence, fitness, and discipline as a family at Storm Taekwondo.',
  benefits: ['Family Bonding', 'Shared Goals', 'Fitness Together', 'Convenience'],
  image: SITE_IMAGES.familyClasses,
  href: '/family-martial-arts-classes'
}, {
  title: 'Self-Defense Classes',
  age: 'Kids, Teens & Adults',
  description: 'Build confidence, awareness, fitness, and practical martial arts fundamentals in a structured Taekwondo environment. Learn how to protect yourself while getting a great workout.',
  benefits: ['Situational Awareness', 'Practical Techniques', 'Confidence', 'Fitness'],
  image: SITE_IMAGES.selfDefense,
  href: '/self-defense-classes'
}, {
  title: 'Competition Team Program',
  age: 'Advanced / Invitation Only',
  description: 'For students ready to compete at a higher level. Led by experienced coaches including a 2x USA National Sparring Champion, this program prepares athletes for local, state, and national Taekwondo tournaments.',
  benefits: ['Elite Coaching', 'Tournament Prep', 'Advanced Sparring', 'Mental Toughness'],
  image: SITE_IMAGES.competitionTeam,
  href: '/competition-team'
}];
export function ProgramsList() {
  return <section className="py-12" data-id="element-2876">
      {programs.map((program, idx) => <div key={idx} className={`py-16 ${idx % 2 === 0 ? 'bg-off-white' : 'bg-paper border-y border-subtle-gray'}`} data-id="element-2877">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2878">
            <div className={`grid lg:grid-cols-2 gap-12 items-center ${idx % 2 === 1 ? 'lg:flex-row-reverse' : ''}`} data-id="element-2879">
              <div className={idx % 2 === 1 ? 'lg:order-2' : ''} data-id="element-2880">
                <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl" data-id="element-2881">
                  <img src={program.image} alt={program.title} className={`block w-full h-full object-cover ${program.title.includes('Competition') ? 'object-top' : 'object-center'}`} data-id="element-2882" />
                  <div className="absolute top-4 left-4 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-2883">
                    {program.age}
                  </div>
                </div>
              </div>
              <div className={idx % 2 === 1 ? 'lg:order-1' : ''} data-id="element-2884">
                <h2 className="text-4xl text-ink mb-6" data-id="element-2885">{program.title}</h2>
                <p className="text-lg text-gray-warm mb-8 leading-relaxed" data-id="element-2886">
                  {program.description}
                </p>

                <div className="mb-8" data-id="element-2887">
                  <h4 className="font-bold text-ink mb-4 uppercase tracking-wide" data-id="element-2888">
                    What Students Learn
                  </h4>
                  <ul className="grid grid-cols-2 gap-3" data-id="element-2889">
                    {program.benefits.map((benefit, bIdx) => <li key={bIdx} className="flex items-center gap-2 text-gray-warm" data-id="element-2890">
                        <CheckCircle2 className="w-5 h-5 text-storm-red shrink-0" data-id="element-2891" />
                        <span data-id="element-2892">{benefit}</span>
                      </li>)}
                  </ul>
                </div>

                <Link to={program.href} className="inline-flex items-center gap-2 btn-primary" data-id="element-2893">
                  Learn More <ArrowRight className="w-5 h-5" data-id="element-2894" />
                </Link>
              </div>
            </div>
          </div>
        </div>)}
    </section>;
}